import { validateCreateClaim } from '@/utils/permission';

// 1、创建路由规则
const routes = [
  // 申请理赔
  {
    path: '/applyClaim',
    name: 'applyClaim',
    component: () => import('@/views/ibuApplyClaim/index.vue'),
    meta: {
      title: 'Claim online',
      KeepAlive: true,
    },
  },
  {
    path: '/pdfViewer',
    name: 'pdfViewer',
    component: () => import('@/views/ibuPdfViewer/index.vue'),
    meta: {
      title: 'PDF Viewer',
    }
  },

  {
    path: '/applyClaim/agreement',
    name: 'agreement',
    component: () => import('@/views/ibuApplyClaim/agreement/index.vue'),
    meta: {
      title: 'Claim agreement',
      isNavOn: false,
      isFullScreen: true, // 不需要侧边栏
    },
  },
  {
    path: '/claimTracking',
    name: 'claimTracking',
    component: () => import('@/views/ibuClaimTracking/ibuLoginPage/index.vue'),
    meta: {
      title: 'Claim tracking',
      isNavOn: false,
      isFullScreen: true, // 不需要侧边栏
    },
  },
  {
    path: '/claimTracking/result',
    name: 'claimTrackingResult',
    component: () => import('@/views/ibuClaimTracking/ibuClaimTrackingResult/index.vue'),
    meta: {
      title: 'Claim tracking',
      isNavOn: false,
      isFullScreen: true, // 不需要侧边栏
    },
  },
  // beforeEnter: validateCreateClaim,
];

export default routes;
